//noScroll
class Common {
  constructor(el,opt){
    this.event();
  }
  event(){

    // ヘッダー メガメニュー
    $('.js-h-mega').hover(
      function (){
        $('.js-hamNameOverlay').addClass('is-active');
        $('.js-hamNameOverlay').css({'z-index': '351'});
        $(this).css({'z-index': '352'});
      },
      function () {
        $('.js-hamNameOverlay').removeClass('is-active');
        $(this).css({'pointerEvents': 'none'});
        setTimeout(() => {
          $('.js-hamNameOverlay').css({'z-index': '200'});
          $(this).css({'z-index': '1'});
          $(this).css({'pointerEvents': 'inherit'});
        }, 300);
      }
    );

    // 追従メニュー フッター到達時非表示
    let options = {
      threshold: [0]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          $('.js-top__fixedBnr').addClass('is-hidden');
        } else {
          $('.js-top__fixedBnr').removeClass('is-hidden');
        }
      });
    }, options);

    let el = document.querySelector('.js-footer')
    observerEnter.observe(el);

    new ScrollHint('.js-scrollable', {
      i18n: {
        scrollable: 'スクロールできます',
      },
      suggestiveShadow: true
    });

  }
}